/**
 * file : Ranking/Index.jsx
 * 설명 : 메인 화면
 */

import Banner7 from "assets/images/banner_img7.jpg"
import Banner5 from "assets/images/banner_img5.jpg"
import Banner6 from "assets/images/banner_img6.jpg"

import Tournament from "./Tournament"
import Prize from "./Prize"
import Bet from "./Bet"
import Win from "./Win"

import { useState } from "react";
import { Link } from 'react-router-dom';
import { Tab, Spinner } from "components/Common/Componentization"

export default function Index() {

  document.title = '랭킹'

  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);

  const titles = ['토너먼트별 랭킹', '상금 랭킹', '베팅 랭킹', '당첨금액 랭킹'];
  const contents = [
    <Tournament setDataLoading={setDataLoading} />,
    <Prize setDataLoading={setDataLoading} />,
    <Bet setDataLoading={setDataLoading} />,
    <Win setDataLoading={setDataLoading} />
  ];

  return (
    <>
      <Spinner show={dataLoading} />
      <div className="container_sub">
        <div className="location">전체토너먼트 &nbsp; &gt; &nbsp; 랭킹</div>
        {/* =================== 사용 미정 =================== */}
        <div className="sub_banner" style={{ display: 'none' }}>
          <div className="big_banner">
            <Link href="#"><img src={Banner7} alt="banner_img7" /></Link>
          </div>
          <div className="second_banner box_style4">
            <ul>
              <li><Link href="#"><img src={Banner6} alt="banner_img5" /></Link></li>
              <li><Link href="#"><img src={Banner5} alt="banner_img6" /></Link></li>
            </ul>
          </div>
        </div>
        <div className="ranking_wrap box_style1">
          <div className="view_bbs">
            <Tab title={titles} content={contents} style={`box_style1`} />
          </div>
        </div>
      </div>
    </>
  )
}